import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/alexa/ic_thr.png'


const _withScopeId = n => (_pushScopeId("data-v-51815890"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "switch-icon",
  src: _imports_0
}, null, -1))

import { getCurrentInstance, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
  portInfor: Object,
},
  setup(__props) {

const props = __props

const { appContext } = getCurrentInstance();
const vm = appContext.config.globalProperties;
console.log("ctx", vm);
const router = useRouter();



const state = reactive({
  pwdSuffixImg: require("@/assets/images/alexa/ic_16_arrow@3x.png"),
});

const jumpPort = () => {
  router.push(
    `/${vm.$commonFunc.getUrlChannelAppID()}/sel-port${vm.$commonFunc.linkUrlParams()}`
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "port",
    onClick: jumpPort
  }, [
    _createElementVNode("span", null, _toDisplayString(__props.portInfor.area), 1),
    _hoisted_1
  ]))
}
}

})